import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  VStack,
  SimpleGrid,
  Text,
  Badge,
  HStack,
  Icon,
} from '@chakra-ui/react';
import { AiOutlineExperiment } from 'react-icons/ai';
import { getTests } from '../api/tests';

export const TestMenu = () => {
  const [tests, setTests] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await getTests();
      setTests(res);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box>
      <VStack spacing={10} py={20} px={[5, 10, 20]}>
        <VStack spacing={3} textAlign="center">
          <Heading color="teal.700" size="2xl">Diagnostic Test Menu</Heading>
          <Text color="gray.600" fontSize="lg">Comprehensive range of diagnostic tests at your service</Text>
        </VStack>

        <SimpleGrid columns={[1, 2, 3]} spacing={8} width="100%">
          {tests.map((test) => (
            <Box
              key={test._id}
              p={6}
              bg="white"
              borderRadius="xl"
              boxShadow="md"
              border="1px solid"
              borderColor="gray.100"
              transition="all 0.3s"
              _hover={{ transform: 'translateY(-5px)', boxShadow: 'xl', borderColor: 'teal.200' }}
            >
              <HStack spacing={4} mb={4}>
                <Box p={3} bg="teal.50" borderRadius="lg" color="teal.500">
                  <Icon as={AiOutlineExperiment} w={6} h={6} />
                </Box>
                <VStack align="start" spacing={0}>
                  <Text fontWeight="bold" fontSize="lg">{test.name}</Text>
                  <Text fontSize="sm" color="gray.500">{test.suitableFor || 'All Ages'}</Text>
                </VStack>
              </HStack>
              <Text color="gray.600" noOfLines={3} mb={4}>
                {test.description}
              </Text>
              <HStack justify="space-between">
                <Text fontWeight="bold" color="teal.600" fontSize="xl">₹{test.price}</Text>
                <Badge colorScheme="teal" borderRadius="full" px={3}>Popular</Badge>
              </HStack>
            </Box>
          ))}
        </SimpleGrid>
      </VStack>
    </Box>
  );
};
